import React, { Fragment } from 'react';
import { useController } from 'react-hook-form';
import { Required, RowComponent } from '../../../styles/global-style';
import { TextXSMall, TextInputLabel } from '../../text';
import { Checkbox } from 'antd';
import { renderTypeError } from '../index.jsx';

const CheckboxComponent = ({ control, item, handleChange }) => {
  const { rules, name, defaultValue, label, properties, dataCy, ...propsInput } = item;
  const { options } = properties;

  const { field, fieldState } = useController({
    control,
    name,
    rules,
    defaultValue,
  });

  const { error } = fieldState;
  const isChecked = Boolean(field.value);

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    field.onChange(checked);
    handleChange?.(checked, item);
  };

  return (
    <Fragment>
      <RowComponent>
        {label && <TextInputLabel text={label} />}
        {rules?.required && <Required>*</Required>}
      </RowComponent>
      <Checkbox
        id={name}
        disabled={item.disabled || false}
        checked={isChecked}
        onChange={handleCheckboxChange}
        {...dataCy}
        {...propsInput}
      >
        {options?.[0]?.label || 'เลือก'}
      </Checkbox>
      <br />
      {error && <TextXSMall text={renderTypeError(item, error)} color="red" />}
    </Fragment>
  );
};

export const MemoizedCheckbox = CheckboxComponent;
